<template>
<div class='mapbox-block'></div>
</template>

<script>
let mapboxgl = global.mapboxgl;

export default {
  name: 'mapbox-block',
  props: {
      center: {
          type: Array,
          default: () => [0,0], // [-122.401605, 37.776385],
      },
      zoom: {
          type: Number,
          default: 11.2,
      },
      interactive: {
          type: Boolean,
          default: true,
      },
  },
  data () {
      return {
          map: null,
      };
  },
  mounted () {
    mapboxgl.accessToken = 'pk.eyJ1IjoicmVnaXNmcmV5IiwiYSI6ImNpa2htcTVtZjAxenR0emo3NGhhYzJlZXkifQ.jbQCGE_nGn7QEPyQJmzxeA';
    this.map = new mapboxgl.Map({
        container: this.$el,
        style: 'mapbox://styles/regisfrey/cjr3zubae16342rs9yflyv96b',
        center: this.center,
        zoom: this.zoom,
        attributionControl: false,
        interactive: this.interactive,
    })
    /*
    .addControl(new mapboxgl.AttributionControl({
        compact: true
    }));
    */
  }
}
</script>

<style lang="scss">
</style>
